import React, { useState } from "react";
import EventList from "./EventList";
import IEvent from "../../models/Event";

interface Props {
  events: IEvent[];
}

type ScheduledType = "Past" | "Today" | "Upcoming"

const FilteredCalendar = ({ events }: Props) => {

  const [scheduledType, setScheduledType] = useState<ScheduledType>("Today");
  const scheduledTypes: ScheduledType[] = ["Past", "Today", "Upcoming"];

  const filterEvents = (filterType: ScheduledType) => {
    const currentDate = new Date();
    const todayStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const todayEnd = new Date(todayStart.getTime() + 24 * 60 * 60 * 1000); // End of today




    switch (filterType) {
      case "Past":
        return events.filter((event) => new Date(event.startTime || event.date) < todayStart);
      case "Today":
        return events.filter((event) => {
          const eventDate = new Date(event.startTime || event.date);
          return eventDate >= todayStart && eventDate < todayEnd;
        });
      case "Upcoming":
        return events.filter((event) => {
          const eventDate = new Date(event.startTime || event.date);

          return (
            eventDate > new Date() || eventDate >= todayEnd
          );
        });
      default:
        return events;
    }
  };

  const filteredEvents = filterEvents(scheduledType).sort((a, b) => {
    const aDate = new Date(a.startTime || a.date).getTime();
    const bDate = new Date(b.startTime || b.date).getTime();

    if (scheduledType === "Past") {
      return bDate - aDate;
    }

    if (scheduledType === "Upcoming") {
      return aDate - bDate;
    }

    if (scheduledType === "Today") {
      return aDate - bDate;
    }

    return 0;
  });

  return (
    <div>
      <div className="text-center text-base font-bold text-[#545455] mb-3">
        Upcoming Live Sessions
      </div>

      <div className="w-full">
        {/* <div className="flex justify-between space-x-4 mb-4"> */}
        <div className="flex justify-center gap-2 mb-4">
          {scheduledTypes.map((type) => (
            <button
              key={type}
              className={`px-3 py-1 text-xs rounded-full transition ${scheduledType === type
                ? "bg-[#5F488A] text-white"
                : "border border-[#545455] text-[#545455]"
                }`}
              onClick={() => setScheduledType(type)}
            >
              {type}
            </button>
          ))}
        </div>
      </div>
      {/* <hr className="mb-4 border-app-blue border-[1px] w-full" /> */}
      <hr className="mb-3 border-[#5F488A]" />
      <div
        className={` ${scheduledType === "Past"
          ? "opacity-50 pointer-events-none"
          : "opacity-100 blur-0"
          }`}
      >
        {filteredEvents.length === 0 && (<div className="p-2 text-black w-full">There are no {scheduledType} events. </div>)}
        {filteredEvents.length > 0 && (<EventList events={filteredEvents} />)}
      </div>
    </div>
  );
};

export default FilteredCalendar;




